import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import crypto from 'crypto';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function formatCurrency(amount: number, currency = 'INR'): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
  }).format(amount);
}

export function generateApiKey(): string {
  return 'pc_' + crypto.randomBytes(24).toString('base64url').replace(/[^a-zA-Z0-9]/g, '');
}

export function generateProxyUsername(): string {
  return 'user_' + crypto.randomBytes(4).toString('hex');
}

export function generateProxyPassword(): string {
  return crypto.randomBytes(12).toString('hex');
}

/**
 * Robust email validation using a fully anchored regex.
 * 🛡️ Sentinel: Prevents suffix bypass attacks.
 * Aligned with backend validation in internal/api/server.go
 */
export function getErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

